import { ActionReply, Comment } from "component/comment";
import { ActionUpvote } from "feature/comments/upvote";
import { CLICK, component, demoFile, extend, POPUP, story } from "system/demo";
import { ActionReportComment, ReportPopup } from 'feature/moderation/report-comment';
import { GUIDELINES } from "feature/question/community-guidelines";

demoFile('feature/moderation/report-comment', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=5220-2966&t=dlCMQ4bQ0Ij7PDHZ-1'
});

const collections = {
    comment: [
        {key: 1, from: 'b', text: 'People who disagree with me should be tortured.'},
    ]
}

const config = {
    commentActions: [ActionReply, ActionUpvote],
    commentRightActions: [ActionReportComment]
}

extend('Comment', 'Report Comment', Comment, {
    config,
    state: {
        collections
    },
    args: {commentKey: '1'},
}, [
    story('Report Comment', [
        CLICK('report'), 
        POPUP(CLICK(GUIDELINES.NO_UNCIVIL)), 
        POPUP(CLICK(GUIDELINES.NO_HARM)), 
        POPUP(CLICK('Report'))
    ])
])

component('Report Popup', ReportPopup, {
    state: {collections},
    config,
    args: {commentKey: '1', onClose: () => {}}
}, [
    story('Report Comment', [
        CLICK(GUIDELINES.NO_SPAM), 
        CLICK('Report')
    ])
])

